import { configureStore } from "@reduxjs/toolkit";
import { createContext } from "react";
import { createDispatchHook, createSelectorHook } from "react-redux";

import filterReducer from "./filter.slice";

const store = configureStore({
  reducer: {
    filter: filterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: {
        ignoredPaths: ["ignoredPath", "ignoredNested.one", "ignoredNested.two"],
      },
    }),
});

export const companyStoreContext = createContext();

export const useCompanySelector = createSelectorHook(companyStoreContext);
export const useCompanyDispatch = createDispatchHook(companyStoreContext);

export default store;
